
export abstract class Constants 
{
    //SOFOTWARE KEYS
    static readonly PROJECT_LABEL       : string = window["software_default_settings"]["global_project_label"]; //taken from global frontend_settings.js
    static readonly DEFAULT_SETTINGS    : Object = window["software_default_settings"];
    static readonly SERVER_URLS         : Object = window["server_urls"];

    //Try to get the settings from LocalStorage.
    //If not exists, It try to access the default settings that is in window variables set by backend with frontend_settings.js
    static getSettingValue(label) 
    {
        var settings = localStorage.getItem(Constants.PROJECT_LABEL + "_software_settings") !== null ? JSON.parse(localStorage.getItem(Constants.PROJECT_LABEL + "_software_settings")) : null;
        if (settings !== null && settings[label] !== null) {
            return settings[label]
        }
        else 
        {
            var default_settings = Constants.DEFAULT_SETTINGS;
            if (default_settings !== null && default_settings[label] !== null) 
            {
                return default_settings[ label ];
            }
            return undefined;
        }
    }

}
